import { render, staticRenderFns } from "./SynonymsForm.vue?vue&type=template&id=f0757c46&scoped=true&lang=pug&"
import script from "./SynonymsForm.vue?vue&type=script&lang=js&"
export * from "./SynonymsForm.vue?vue&type=script&lang=js&"
import style0 from "./SynonymsForm.vue?vue&type=style&index=0&id=f0757c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0757c46",
  null
  
)

export default component.exports